<script setup lang="ts">
import {
  toRef,
} from 'vue';

import VFormFloatLabelInputWrapper
  from '@modules/forms/components/inputs/VFormFloatLabelInputWrapper/VFormFloatLabelInputWrapper.vue';
import VFormInputWrapper
  from '@modules/forms/components/inputs/VFormInputWrapper/VFormInputWrapper.vue';

import type {
  VFormTextareaEmits,
  VFormTextareaProps,
} from './types';
import { useInputInnerValue } from '../composables';

const props = withDefaults(defineProps<VFormTextareaProps>(), {});
const emit = defineEmits<VFormTextareaEmits>();

const { innerValue } = useInputInnerValue(toRef(props, 'value'));
</script>

<template>
  <VFormInputWrapper v-data-qa-auto-id="'VFormTextarea'"
    :errors="errors"
    :hide-errors="hideErrors"
    :readonly="readonly"
    :class="isFullWidth ? 'w-full' : 'input-max-width'"
    :description="description"
    :description-severity="descriptionSeverity"
  >
    <VFormFloatLabelInputWrapper
      :name="name"
      :label="label"
      :required="required"
      :readonly="readonly"
    >
      <PInputTextarea
        v-model="innerValue"
        :name="name"
        auto-resize
        rows="2"
        :placeholder="placeholder"
        :required="required"
        :input-id="name"
        :readonly="readonly"
        :disabled="disabled"
        class="w-full"
        :class="{ 'p-invalid': isInvalid && !readonly, 'input-readonly': readonly }"
        :autocomplete="autocomplete ? autocomplete : 'off'"
        variant="filled"
        @blur="emit('blur', innerValue)"
        @focus="emit('focus', innerValue)"
        @change="emit('change', innerValue)"
        @input="emit('input', innerValue)"
      />
    </VFormFloatLabelInputWrapper>
  </VFormInputWrapper>
</template>
